import { render, staticRenderFns } from "./GardenTitle.vue?vue&type=template&id=7a1ac5d6"
import script from "./GardenTitle.vue?vue&type=script&lang=ts"
export * from "./GardenTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports